// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.nav');
  
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function() {
      nav.classList.toggle('active');
    });
  }

  // Newsletter form handling
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      // Shopify handles the form submission, but we can add custom logic here if needed
    });
  }

  // Add smooth scrolling for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href.length > 1) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // Product gallery image switching
  const galleryItems = document.querySelectorAll('.product-detail__gallery-item');
  const mainImage = document.getElementById('product-main-image');
  const gallery = document.getElementById('product-gallery');
  
  if (galleryItems.length > 0 && mainImage) {
    galleryItems.forEach(function(item) {
      item.addEventListener('click', function() {
        const srcset = this.getAttribute('data-media-srcset');
        const src = this.getAttribute('data-media-src');
        
        if (src) {
          mainImage.srcset = srcset || '';
          mainImage.src = src;
          
          // Update active state
          galleryItems.forEach(function(galleryItem) {
            galleryItem.classList.remove('active');
          });
          this.classList.add('active');
          
          // Scroll gallery item into view
          if (gallery) {
            this.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        }
      });
    });
  }
  
  // Gallery scroll buttons
  const scrollPrevBtn = document.querySelector('.gallery-scroll-prev');
  const scrollNextBtn = document.querySelector('.gallery-scroll-next');
  
  if (scrollPrevBtn && gallery) {
    scrollPrevBtn.addEventListener('click', function() {
      gallery.scrollBy({ left: -220, behavior: 'smooth' });
    });
  }
  
  if (scrollNextBtn && gallery) {
    scrollNextBtn.addEventListener('click', function() {
      gallery.scrollBy({ left: 220, behavior: 'smooth' });
    });
  }

  // Product variant selection handling
  const productForm = document.querySelector('[data-type="add-to-cart-form"]');
  const variantSelects = document.querySelectorAll('.product-variant-select');
  const variantIdInput = document.getElementById('product-variant-id');
  const addToCartButton = document.querySelector('.product-form__submit');
  
  if (productForm && variantSelects.length > 0) {
    // Store product data - will be populated from Shopify's product JSON
    const productData = {
      id: productForm.getAttribute('data-product-id'),
      variants: JSON.parse(document.getElementById('product-variants-data')?.textContent || '[]')
    };
    
    function updateVariant() {
      const selectedOptions = [];
      variantSelects.forEach(function(select) {
        selectedOptions.push(select.value);
      });
      
      // Find matching variant based on selected options
      const matchingVariant = productData.variants.find(function(variant) {
        const variantOptions = [variant.option1, variant.option2, variant.option3].filter(function(opt) {
          return opt !== null && opt !== '';
        });
        
        if (variantOptions.length !== selectedOptions.length) return false;
        
        return variantOptions.every(function(opt, index) {
          return opt === selectedOptions[index];
        });
      });
      
      if (matchingVariant) {
        // Update variant ID
        if (variantIdInput) {
          variantIdInput.value = matchingVariant.id;
          variantIdInput.disabled = false;
        }
        
        // Update variant image if available
        if (matchingVariant.featured_media && matchingVariant.featured_media.src && mainImage) {
          mainImage.src = matchingVariant.featured_media.src;
          mainImage.srcset = '';
          // Update active gallery item if it matches
          galleryItems.forEach(function(item) {
            if (item.getAttribute('data-media-id') == matchingVariant.featured_media.id) {
              galleryItems.forEach(function(galleryItem) {
                galleryItem.classList.remove('active');
              });
              item.classList.add('active');
            }
          });
        }
        
        // Update availability
        const availabilityElement = document.querySelector('.product-detail__availability');
        if (availabilityElement) {
          if (matchingVariant.available) {
            availabilityElement.innerHTML = '<p class="product-available"><span class="availability-icon">✓</span> In Stock</p>';
          } else {
            availabilityElement.innerHTML = '<p class="product-unavailable"><span class="availability-icon">✗</span> Out of Stock</p>';
          }
        }
        
        // Update SKU
        const skuDisplay = document.getElementById('product-sku-display');
        const skuValue = document.getElementById('variant-sku');
        if (skuDisplay && skuValue) {
          if (matchingVariant.sku) {
            skuValue.textContent = matchingVariant.sku;
            skuDisplay.style.display = 'block';
          } else {
            skuDisplay.style.display = 'none';
          }
        }
        
        // Update add to cart button
        if (addToCartButton) {
          if (matchingVariant.available) {
            addToCartButton.disabled = false;
            addToCartButton.querySelector('span').textContent = 'Add to Cart';
          } else {
            addToCartButton.disabled = true;
            addToCartButton.querySelector('span').textContent = 'Sold Out';
          }
        }
      }
    }
    
    // Add event listeners to variant selects
    variantSelects.forEach(function(select) {
      select.addEventListener('change', updateVariant);
    });
    
    // Initial update
    updateVariant();
  }
});


